// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons+Round&display=swap);"]);
exports.push([module.id, "@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css);"]);
// Module
exports.push([module.id, "div#_pg-app{padding:15px}div#_pg-app *{box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
